import React from "react";
import "./App.css";
import { usePaths } from "./BEDROCK/paths";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LandingPage } from "./BEDROCK/pages/landing/landing-page";
import { AuthPage } from "BEDROCK/pages/auth/supabase/auth-page";
import { ResetPasswordPage } from "BEDROCK/pages/auth/supabase/reset-password-page";
import { PosterEditor } from "PosterEditor/PosterEditor";
import { ProjectListPage } from "project-list/project-list-page";
import { TemplateListAdmin } from "admin/templates-admin/template-list-admin";
import { CollectionsListAdmin } from "admin/collections-admin/collections-list-admin";
import { CollectionDetailAdmin } from "admin/collections-admin/collection-detail-admin";
import { Checkout } from "BEDROCK/pages/checkout/checkout";
import { CheckoutReview } from "checkout-review/checkout-review";
import { CheckoutConfirmation } from "BEDROCK/pages/checkout/checkout-confirmation";
import { ProtectedRoute } from "BEDROCK/auth/projected-route";
import { ProcessOrder } from "process-order/process-order";
import { CollectionListPage } from "collection-pages/collection-list-pages/collection-list-page";
import { CollectionPage } from "collection-pages/single-collection-pages/collection-page";
import { MyOrdersPage } from "orders/my-orders-page";
import { MyAccountPage } from "my-account/my-account-page";
import { TermsPage } from "info-pages/terms";
import { PrivacyPage } from "info-pages/privacy";
import { CookiesPage } from "info-pages/cookies";

function App() {
  const paths = usePaths();

  const protectAllRoutes = false;

  return (
    <Routes>
      <Route
        path={paths.home}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <LandingPage />
            </ProtectedRoute>
          ) : (
            <LandingPage />
          )
        }
      />
      <Route path={paths.auth} element={<AuthPage />} />
      <Route
        path={paths.resetPassword}
        element={
          <ProtectedRoute>
            <ResetPasswordPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={paths.landing}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <LandingPage />
            </ProtectedRoute>
          ) : (
            <LandingPage />
          )
        }
      />

      <Route
        path={paths.mapEditor}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <PosterEditor />
            </ProtectedRoute>
          ) : (
            <PosterEditor />
          )
        }
      />

      <Route
        path={`${paths.mapEditor}/:projectId`}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <PosterEditor />
            </ProtectedRoute>
          ) : (
            <PosterEditor />
          )
        }
      />

      <Route
        path={`${paths.templateEditor}/:templateId`}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <PosterEditor />
            </ProtectedRoute>
          ) : (
            <PosterEditor />
          )
        }
      />
      <Route
        path={paths.projectList}
        element={
          <ProtectedRoute>
            <ProjectListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.templateListAdmin}
        element={
          <ProtectedRoute>
            <TemplateListAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.collectionsAdmin}
        element={
          <ProtectedRoute>
            <CollectionsListAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${paths.collectionEditAdmin}/:collectionId`}
        element={
          <ProtectedRoute>
            <CollectionDetailAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${paths.processOrder}/:projectId`}
        element={
          <ProtectedRoute>
            <ProcessOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.checkoutReview}
        element={
          <ProtectedRoute>
            <CheckoutReview />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.checkout}
        element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${paths.checkoutConfirmation}/:orderId`}
        element={
          <ProtectedRoute>
            <CheckoutConfirmation />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${paths.collectionList}/:collectionListHandle`}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <CollectionListPage />
            </ProtectedRoute>
          ) : (
            <CollectionListPage />
          )
        }
      />

      <Route
        path={`${paths.collection}/:collectionId`}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <CollectionPage />
            </ProtectedRoute>
          ) : (
            <CollectionPage />
          )
        }
      />
      <Route
        path={paths.myOrders}
        element={
          protectAllRoutes ? (
            <ProtectedRoute>
              <MyOrdersPage />
            </ProtectedRoute>
          ) : (
            <MyOrdersPage />
          )
        }
      />
      <Route
        path={paths.myAccount}
        element={
          <ProtectedRoute>
            <MyAccountPage />
          </ProtectedRoute>
        }
      />
      <Route path={paths.terms} element={<TermsPage />} />
      <Route path={paths.privacyPolicy} element={<PrivacyPage />} />
      <Route path={paths.cookiePolicy} element={<CookiesPage />} />
    </Routes>
  );
}

export default App;
